import { AccountTree, AddAlert, CalendarMonth, Chat, Dashboard, Groups, HelpOutline, LiveHelp, MessageRounded, Pages, People, Person, Redeem, School } from "@mui/icons-material";
import theme from "../theme";
import CommonFeatureIcon from "./components/CommonFeatureIcon";
import moment from "moment";

export const removeEmptyFields = (obj) => {
  const cleaned = { ...obj };
  Object.keys(cleaned).forEach(key => {
    if (cleaned[key] === null || cleaned[key] === undefined || cleaned[key] === '') {
      delete cleaned[key];
    }
  });
  return cleaned;
};

export const Plans = [{
  id: 1,
  name: 'Free',
  price: 0,
  features: [1, 2, 3, 4, 5],
  isActive: false,
  date: '2026-01-10'
}, {
  id: 2,
  name: 'Gold',
  price: 19,
  features: [1, 2, 3, 4, 5],
  isActive: true,
  date: '2026-01-10'
}, {
  id: 3,
  name: 'Platinum',
  price: 79,
  features: [1, 2, 3, 4, 5],
  isActive: false,
  date: '2026-01-10'
}, {
  id: 4,
  name: 'Diamond',
  price: 39,
  features: [1, 2, 3, 4, 5],
  isActive: false,
  date: '2026-01-10'
}];

export const FeatureList = [{
  id: 1, title: 'Basic dashboard view'
},
{
  id: 2, title: 'Add up to 5 colleges'
},
{
  id: 3, title: 'Track test scores'
},
{
  id: 4, title: 'Basic calendar'
},
{
  id: 5, title: '1 counselor question/week'
},
{
  id: 6, title: 'AI college suggestions'
},
{
  id: 7, title: 'Advanced analytics'
},
{
  id: 8, title: 'Unlimited Q&A'
}];

export const NotificationType = {
  1: 'Upcoming Deadline',
  2: 'College Update',
  3: 'AI Recommendation',
  4: 'Achievement Unlocked',
  5: 'Parent Update'
}

export const NotificationPriorityType = {
  URGENT: 'Urgent',
  HIGH: 'High Priority',
  NORMAL: 'Medium Priority',
  LOW: 'Low Priority'
}

export const StepperContent = {
  "Step-1": {
    title: 'Basic Academic Information',
    subTitle: 'Add your essential academic details to complete your profile.'
  },
  "Step-2": {
    title: 'Extracurricular Activities',
    subTitle: `Add the activities you've participated in beyond academics.`
  },
  "Step-3": {
    title: 'Coding/Technology/Skills',
    subTitle: 'Add your technical skills and coding expertise.'
  },
  "Step-4": {
    title: 'STEM Research Projects',
    subTitle: `Add the research work or projects you've completed..`
  }
};

export const Academics = [
  { value: 'CURRENT', label: 'Current' },
  { value: 'PAST', label: 'Past' }
];

export const Status = [
  { value: 'ENROLLED', label: 'Enrolled' },
  { value: 'INPROGRESS', label: 'In Progress' },
  { value: 'COMPLETED', label: 'Completed' }
];

export const ProjectStatus = {
  Enrolled: 'ENROLLED',
  InProgress: 'INPROGRESS',
  Completed: 'COMPLETED'
}

export const ProjectDisplayStatus = {
  ENROLLED: 'Enrolled',
  INPROGRESS: 'In Progress',
  COMPLETED: 'Completed'
};

export const ProjectCategory = [
  { value: 'AI/ML', label: 'AI/ML' },
  { value: 'BIO_TECH', label: 'Bio Tech' },
  { value: 'ENGINEERING', label: 'Engineering' },
  { value: 'SOCIAL_SCIENCE', label: 'Social Science' }
];

export const SubjectArea = [
  { value: 1, label: 'Academics' },
  { value: 2, label: 'Ap Exam' },
  { value: 3, label: 'SAT/ACT' },
];

export const ExamSubjectArea = [
  { value: 'ACT_SAT', label: 'SAT/ACT' },
  { value: 'ACADEMICS', label: 'Academics' },
  { value: 'AP_EXAMS', label: 'AP Exam' },
  { value: 'SKILL', label: 'Skills' }
];


export const SubjectAreaObj = {
  1: 'ACADEMICS',
  2: 'AP_EXAM',
  3: 'SAT_SCT'
}

export const AreaObj = {
  'ACADEMICS': 'ACADEMICS',
  'AP_EXAM': 'AP_EXAMS',
  'SAT_SCT': 'ACT_SAT',
  'Skills': 'SKILL'
}

export const AreaObject = {
  'ACADEMICS': 1,
  'AP_EXAM': 2,
  'SAT_SCT': 3
}

export const EnrollmentStatus = [
  { value: 1, label: 'Enrolled' },
  { value: 2, label: 'Completed' },
  { value: 3, label: 'Dropped' }
];

export const EnrollmentStatusObj = {
  1: 'ENROLLED',
  2: 'COMPLETED',
  3: 'DROPPED'
}

export const Subjects = [
  { value: 1, label: 'Maths' },
  { value: 2, label: 'Science' },
  { value: 3, label: 'Languages' }
];

export const ExamAttempts = [
  { value: 1, label: 'Yes' },
  { value: 2, label: 'No' }
];

export const ExamAttempt = [
  { value: 'FIRST_TIME', label: 'First Time' },
  { value: 'SECOND_TIME', label: 'Second Time' },
  { value: "THIRD_TIME", label: 'Third Time' }
];


export const SkipReasons = [
  { value: `I don't have my transcripts yet`, label: `I don't have my transcripts yet` },
  { value: 'I will fill it later', label: 'I will fill it later' }
];

export const ContactReasons = [
  { value: "Can't log in to my account", label: "Can't log in to my account" },
  { value: "Forgot password/Need password reset", label: "Forgot password/Need password reset" },
  { value: "Account verification/activation issue", label: "Account verification/activation issue" },
  { value: "Need to update email/phone number", label: "Need to update email/phone number" },
  { value: "Account deletion request", label: "Account deletion request" },
  { value: "Website/app not loading properly", label: "Website/app not loading properly" },
  { value: "Error message on screen", label: "Error message on screen" },
  { value: "Page not found (404 error)", label: "Page not found (404 error)" },
  { value: "Slow loading/performance issues", label: "Slow loading/performance issues" },
  { value: "Mobile app not working", label: "Mobile app not working" },
  { value: "File upload not working", label: "File upload not working" },
  { value: "Video/audio playback issues", label: "Video/audio playback issues" },
  { value: "Can't find a specific college", label: "Can't find a specific college" },
  { value: "Incorrect college information", label: "Incorrect college information" },
  { value: "College match results unclear", label: "College match results unclear" },
  { value: "Missing college/university in database", label: "Missing college/university in database" },
  { value: "Scholarship matching issue", label: "Scholarship matching issue" },
  { value: "Application deadline questions", label: "Application deadline questions" },
  { value: "Document submission help needed", label: "Document submission help needed" },
  { value: "Application status tracking issue", label: "Application status tracking issue" },
  { value: "Recommendation letter process", label: "Recommendation letter process" },
  { value: "Essay/personal statement guidance", label: "Essay/personal statement guidance" },
  { value: "Course selection advice needed", label: "Course selection advice needed" },
  { value: "GPA calculation questions", label: "GPA calculation questions" },
  { value: "Test preparation (SAT/ACT) resources", label: "Test preparation (SAT/ACT) resources" },
  { value: "Academic timeline planning help", label: "Academic timeline planning help" },
  { value: "Extracurricular activity guidance", label: "Extracurricular activity guidance" },
  { value: "Parent account setup issue", label: "Parent account setup issue" },
  { value: "Can't track child's progress", label: "Can't track child's progress" },
  { value: "Privacy/monitoring questions", label: "Privacy/monitoring questions" },
  { value: "Communication with counselors", label: "Communication with counselors" },
  { value: "Financial planning resources", label: "Financial planning resources" },
  { value: "Scholarship application help", label: "Scholarship application help" },
  { value: "Financial aid (FAFSA) guidance", label: "Financial aid (FAFSA) guidance" },
  { value: "Tuition fee questions", label: "Tuition fee questions" },
  { value: "Payment/billing issue", label: "Payment/billing issue" },
  { value: "Refund request", label: "Refund request" },
  { value: "Subscription/payment problem", label: "Subscription/payment problem" },
  { value: "Invoice/billing query", label: "Invoice/billing query" },
  { value: "Premium feature access issue", label: "Premium feature access issue" },
  { value: "Free trial questions", label: "Free trial questions" },
  { value: "Subscription cancellation", label: "Subscription cancellation" },
  { value: "Plan upgrade/downgrade", label: "Plan upgrade/downgrade" },
  { value: "Data privacy concerns", label: "Data privacy concerns" },
  { value: "Security concern/suspicious activity", label: "Security concern/suspicious activity" },
  { value: "Request to remove personal information", label: "Request to remove personal information" },
  { value: "Report inappropriate content", label: "Report inappropriate content" },
  { value: "Copyright infringement report", label: "Copyright infringement report" },
  { value: "Not receiving email notifications", label: "Not receiving email notifications" },
  { value: "Too many/too few notifications", label: "Too many/too few notifications" },
  { value: "SMS alerts not working", label: "SMS alerts not working" },
  { value: "Calendar sync issues", label: "Calendar sync issues" },
  { value: "Update notification preferences", label: "Update notification preferences" },
  { value: "Feature suggestion/request", label: "Feature suggestion/request" },
  { value: "Bug report", label: "Bug report" },
  { value: "Website usability feedback", label: "Website usability feedback" },
  { value: "General improvement suggestion", label: "General improvement suggestion" },
  { value: "Accessibility improvement request", label: "Accessibility improvement request" },
  { value: "Counselor account registration", label: "Counselor account registration" },
  { value: "Student management tool issue", label: "Student management tool issue" },
  { value: "School partnership inquiry", label: "School partnership inquiry" },
  { value: "Bulk student upload problem", label: "Bulk student upload problem" },
  { value: "Reporting feature question", label: "Reporting feature question" },
  { value: "College/university partnership inquiry", label: "College/university partnership inquiry" },
  { value: "School district collaboration", label: "School district collaboration" },
  { value: "Affiliate program inquiry", label: "Affiliate program inquiry" },
  { value: "API access for developers", label: "API access for developers" },
  { value: "Press/media inquiry", label: "Press/media inquiry" },
  { value: "How to use a specific feature", label: "How to use a specific feature" },
  { value: "Career counseling request", label: "Career counseling request" },
  { value: "Mentorship program query", label: "Mentorship program query" },
  { value: "Event/workshop information", label: "Event/workshop information" },
  { value: "Share success story/testimonial", label: "Share success story/testimonial" },
  { value: "Terms of Service clarification", label: "Terms of Service clarification" },
  { value: "Privacy policy questions", label: "Privacy policy questions" },
  { value: "Other (please specify)", label: "Other (please specify)" }
];

export const ActivitiesAt = [
  { value: 1, label: `School` },
  { value: 2, label: 'Outside' }
];

export const ActivitiesStatus = [
  { value: 'COMPLETED', label: `Completed` },
  { value: 'INPROGRESS', label: 'In Progress' }
];

export const ProficiencyLevels = [
  { value: 'BEGINNER', label: `Beginner` },
  { value: 'INTERMEDIATE', label: `Intermediate` },
  { value: 'ADVANCED', label: `Advanced` },
];

export const Durations = [
  { value: 1, label: `1 month` },
  { value: 2, label: `6 months` },
];

export const Profiles = [
  { value: 'RESEARCH', label: `Research` },
  { value: 'PROJECT', label: `Projects` }
];

export const ProfilesObj = {
  Research: 'RESEARCH',
  Project: 'PROJECT'
};

export const ProjectTypes = [
  { value: 'DCP_PROJECT', label: `DCP Project` },
  { value: 'EXTERNAL', label: `External Project` }
];

export const ProjectTypeObj = {
  dcp: 'DCP_PROJECT',
  ext: 'EXTERNAL'
}

export const FirstTimes = [
  { value: 'FIRST_TIME', label: `First Time` },
  { value: 'EXPANDING', label: `Expanding` }
];

export const Types = [
  { value: 'ENHANCEMENT', label: `Enhancement` },
  { value: 'NEW', label: `New` }
];

export const ProjectDurations = [
  { value: 1, label: `1 month` },
  { value: 2, label: `3 - 6 months` },
];

export const PreferredDurations = [
  { value: 1, label: `1 month` },
  { value: 2, label: `3 month` },
  { value: 3, label: `6 month` },
  { value: 4, label: `1 year` },
];

export const durationOptions = [
  { label: '5 minutes', value: 5 },
  { label: '10 minutes', value: 10 },
  { label: '15 minutes', value: 15 },
  { label: '20 minutes', value: 20 },
  { label: '25 minutes', value: 25 },
  { label: '30 minutes', value: 30 },
  { label: '35 minutes', value: 35 },
  { label: '40 minutes', value: 40 },
  { label: '45 minutes', value: 45 },
  { label: '50 minutes', value: 50 },
  { label: '55 minutes', value: 55 },
  { label: '60 minutes (1 hour)', value: 60 },
  { label: '90 minutes (1.5 hours)', value: 90 },
  { label: '120 minutes (2 hours)', value: 120 },
];

export const IntentOutCome = [
  { value: 1, label: `Strengthen college application profile` },
  { value: 2, label: `Secure admission to target colleges` },
  { value: 3, label: `Improve academic skills/knowledge` },
  { value: 4, label: `Build subject expertise for intended major` },
  { value: 5, label: `Develop research capability` },
  { value: 6, label: `Publish a paper / project report` },
];

export const LearningStyles = [
  { value: 1, label: `Visual – learn through diagrams, charts, videos` },
  { value: 2, label: `Auditory – learn through explanations & discussion` },
  { value: 3, label: `Reading/Writing – notes, articles, structured text` },
  { value: 4, label: `Kinesthetic – hands-on practice & activities` },
  { value: 5, label: `Project-Based – learn by building real projects` },
  { value: 6, label: `Collaborative – group learning & peer interaction` },
  { value: 7, label: `Self-Paced – independent, flexible schedule` },
  { value: 8, label: `Guided – structured mentoring with clear steps` },
];

export const Days = [
  { value: 1, label: `Sunday` },
  { value: 2, label: `Monday` },
  { value: 3, label: `Tuesday` },
  { value: 4, label: `Wednesday` },
  { value: 5, label: `Thursday` },
  { value: 6, label: `Friday` },
  { value: 7, label: `Saturday` }
];

export const Time = [
  { value: 1, label: `12:00 AM - 1:00 AM` },
  { value: 2, label: `1:00 AM - 2:00 AM` },
  { value: 3, label: `2:00 AM - 3:00 AM` },
  { value: 4, label: `3:00 AM - 4:00 AM` },
  { value: 5, label: `4:00 AM - 5:00 AM` },
  { value: 6, label: `5:00 AM - 6:00 AM` },
  { value: 7, label: `6:00 AM - 7:00 AM` },
  { value: 8, label: `7:00 AM - 8:00 AM` },
  { value: 9, label: `8:00 AM - 9:00 AM` },
  { value: 10, label: `9:00 AM - 10:00 AM` },
  { value: 11, label: `10:00 AM - 11:00 AM` },
  { value: 12, label: `11:00 AM - 12:00 PM` },
  { value: 13, label: `12:00 PM - 1:00 PM` },
  { value: 14, label: `1:00 PM - 2:00 PM` },
  { value: 15, label: `2:00 PM - 3:00 PM` },
  { value: 16, label: `3:00 PM - 4:00 PM` },
  { value: 17, label: `4:00 PM - 5:00 PM` },
  { value: 18, label: `5:00 PM - 6:00 PM` },
  { value: 19, label: `6:00 PM - 7:00 PM` },
  { value: 20, label: `7:00 PM - 8:00 PM` },
  { value: 21, label: `8:00 PM - 9:00 PM` },
  { value: 22, label: `9:00 PM - 10:00 PM` },
  { value: 23, label: `10:00 PM - 11:00 PM` },
  { value: 24, label: `11:00 PM - 12:00 AM` }
];

export const Timezones = [
  // GMT-12 to GMT-9
  { value: "Pacific/Midway", label: "(GMT-11:00) Midway Island, Samoa" },
  { value: "Pacific/Honolulu", label: "(GMT-10:00) Hawaii" },
  { value: "America/Anchorage", label: "(GMT-9:00) Alaska" },

  // GMT-8
  { value: "America/Los_Angeles", label: "(GMT-8:00) Pacific Time (US & Canada)" },
  { value: "America/Tijuana", label: "(GMT-8:00) Tijuana" },

  // GMT-7
  { value: "America/Denver", label: "(GMT-7:00) Mountain Time (US & Canada)" },
  { value: "America/Phoenix", label: "(GMT-7:00) Arizona" },
  { value: "America/Chihuahua", label: "(GMT-7:00) Chihuahua, La Paz, Mazatlan" },

  // GMT-6
  { value: "America/Chicago", label: "(GMT-6:00) Central Time (US & Canada)" },
  { value: "America/Mexico_City", label: "(GMT-6:00) Mexico City" },
  { value: "America/Regina", label: "(GMT-6:00) Saskatchewan" },
  { value: "America/Guatemala", label: "(GMT-6:00) Central America" },

  // GMT-5
  { value: "America/New_York", label: "(GMT-5:00) Eastern Time (US & Canada)" },
  { value: "America/Bogota", label: "(GMT-5:00) Bogota, Lima, Quito" },
  { value: "America/Indiana/Indianapolis", label: "(GMT-5:00) Indiana (East)" },

  // GMT-4
  { value: "America/Halifax", label: "(GMT-4:00) Atlantic Time (Canada)" },
  { value: "America/Caracas", label: "(GMT-4:00) Caracas, La Paz" },
  { value: "America/Santiago", label: "(GMT-4:00) Santiago" },

  // GMT-3:30
  { value: "America/St_Johns", label: "(GMT-3:30) Newfoundland" },

  // GMT-3
  { value: "America/Sao_Paulo", label: "(GMT-3:00) Brasilia" },
  { value: "America/Argentina/Buenos_Aires", label: "(GMT-3:00) Buenos Aires" },
  { value: "America/Godthab", label: "(GMT-3:00) Greenland" },

  // GMT-2 to GMT-1
  { value: "Atlantic/South_Georgia", label: "(GMT-2:00) Mid-Atlantic" },
  { value: "Atlantic/Azores", label: "(GMT-1:00) Azores" },

  // GMT+0
  { value: "Europe/London", label: "(GMT+0:00) London, Dublin, Edinburgh" },
  { value: "Atlantic/Reykjavik", label: "(GMT+0:00) Monrovia, Reykjavik" },

  // GMT+1
  { value: "Europe/Paris", label: "(GMT+1:00) Paris, Madrid, Brussels, Copenhagen" },
  { value: "Europe/Berlin", label: "(GMT+1:00) Amsterdam, Berlin, Rome, Stockholm" },
  { value: "Europe/Warsaw", label: "(GMT+1:00) Warsaw, Belgrade, Bratislava, Budapest" },
  { value: "Africa/Lagos", label: "(GMT+1:00) West Central Africa" },

  // GMT+2
  { value: "Europe/Athens", label: "(GMT+2:00) Athens, Istanbul, Minsk" },
  { value: "Europe/Bucharest", label: "(GMT+2:00) Bucharest" },
  { value: "Africa/Cairo", label: "(GMT+2:00) Cairo" },
  { value: "Africa/Johannesburg", label: "(GMT+2:00) Harare, Pretoria" },
  { value: "Asia/Jerusalem", label: "(GMT+2:00) Jerusalem" },

  // GMT+3
  { value: "Europe/Moscow", label: "(GMT+3:00) Moscow, St. Petersburg" },
  { value: "Asia/Baghdad", label: "(GMT+3:00) Baghdad" },
  { value: "Asia/Kuwait", label: "(GMT+3:00) Kuwait, Riyadh" },
  { value: "Africa/Nairobi", label: "(GMT+3:00) Nairobi" },

  // GMT+3:30
  { value: "Asia/Tehran", label: "(GMT+3:30) Tehran" },

  // GMT+4
  { value: "Asia/Dubai", label: "(GMT+4:00) Abu Dhabi, Muscat" },
  { value: "Asia/Baku", label: "(GMT+4:00) Baku, Tbilisi, Yerevan" },
  { value: "Asia/Tbilisi", label: "(GMT+4:00) Tbilisi" },
  { value: "Asia/Yerevan", label: "(GMT+4:00) Yerevan" },
  { value: "Indian/Mauritius", label: "(GMT+4:00) Port Louis" },

  // GMT+4:30
  { value: "Asia/Kabul", label: "(GMT+4:30) Kabul" },

  // GMT+5
  { value: "Asia/Yekaterinburg", label: "(GMT+5:00) Ekaterinburg" },
  { value: "Asia/Karachi", label: "(GMT+5:00) Islamabad, Karachi, Tashkent" },
  { value: "Asia/Tashkent", label: "(GMT+5:00) Tashkent" },

  // GMT+5:30
  { value: "Asia/Kolkata", label: "(GMT+5:30) Chennai, Kolkata, Mumbai, New Delhi" },
  { value: "Asia/Colombo", label: "(GMT+5:30) Sri Jayawardenepura" },

  // GMT+5:45
  { value: "Asia/Kathmandu", label: "(GMT+5:45) Kathmandu" },

  // GMT+6
  { value: "Asia/Dhaka", label: "(GMT+6:00) Dhaka" },
  { value: "Asia/Almaty", label: "(GMT+6:00) Astana" },
  { value: "Asia/Rangoon", label: "(GMT+6:00) Yangon (Rangoon)" },

  // GMT+6:30
  { value: "Asia/Yangon", label: "(GMT+6:30) Yangon (Rangoon)" },
  { value: "Indian/Cocos", label: "(GMT+6:30) Cocos Islands" },

  // GMT+7
  { value: "Asia/Bangkok", label: "(GMT+7:00) Bangkok, Hanoi, Jakarta" },
  { value: "Asia/Jakarta", label: "(GMT+7:00) Jakarta" },
  { value: "Asia/Krasnoyarsk", label: "(GMT+7:00) Krasnoyarsk" },

  // GMT+8
  { value: "Asia/Shanghai", label: "(GMT+8:00) Beijing, Shanghai, Chongqing" },
  { value: "Asia/Singapore", label: "(GMT+8:00) Singapore, Kuala Lumpur" },
  { value: "Asia/Taipei", label: "(GMT+8:00) Taipei" },
  { value: "Australia/Perth", label: "(GMT+8:00) Perth" },
  { value: "Asia/Irkutsk", label: "(GMT+8:00) Irkutsk" },

  // GMT+9
  { value: "Asia/Tokyo", label: "(GMT+9:00) Tokyo, Osaka, Sapporo" },
  { value: "Asia/Seoul", label: "(GMT+9:00) Seoul" },
  { value: "Asia/Yakutsk", label: "(GMT+9:00) Yakutsk" },
  { value: "Pacific/Palau", label: "(GMT+9:00) Palau" },

  // GMT+9:30
  { value: "Australia/Adelaide", label: "(GMT+9:30) Adelaide" },
  { value: "Australia/Darwin", label: "(GMT+9:30) Darwin" },

  // GMT+10
  { value: "Australia/Sydney", label: "(GMT+10:00) Sydney, Melbourne" },
  { value: "Australia/Brisbane", label: "(GMT+10:00) Brisbane" },
  { value: "Australia/Hobart", label: "(GMT+10:00) Hobart" },
  { value: "Pacific/Guam", label: "(GMT+10:00) Guam, Port Moresby" },
  { value: "Asia/Vladivostok", label: "(GMT+10:00) Vladivostok" },

  // GMT+11
  { value: "Asia/Magadan", label: "(GMT+11:00) Magadan" },
  { value: "Pacific/Noumea", label: "(GMT+11:00) New Caledonia" },
  { value: "Pacific/Pohnpei", label: "(GMT+11:00) Ponape" },

  // GMT+12
  { value: "Pacific/Auckland", label: "(GMT+12:00) Auckland, Wellington" },
  { value: "Pacific/Fiji", label: "(GMT+12:00) Fiji" },
  { value: "Asia/Kamchatka", label: "(GMT+12:00) Kamchatka" },

  // GMT+13
  { value: "Pacific/Tongatapu", label: "(GMT+13:00) Nuku'alofa" },

  // GMT+14
  { value: "Pacific/Kiritimati", label: "(GMT+14:00) Kiritimati" }
];

export const Frequency = [
  { value: 1, label: `Daily` },
  { value: 2, label: `Every alternate day` },
  { value: 3, label: `Twice a week` },
  { value: 4, label: `Weekly` },
  { value: 5, label: `Biweekly` }
];

export const Duration = [
  { value: 1, label: `30 Minute` },
  { value: 2, label: `1 hour` },
  { value: 3, label: `2 hour` }
];

export const StudentGrade = [{
  value: 'GRADE_9', label: '9th Grade'
}, {
  value: 'GRADE_10', label: '10th Grade'
}, {
  value: 'GRADE_11', label: '11th Grade'
}, {
  value: 'GRADE_12', label: '12th Grade'
}];

export const DisplayGrade = {
  GRADE_9: 'Grade 9',
  GRADE_10: 'Grade 10',
  GRADE_11: 'Grade 11',
  GRADE_12: 'Grade 12'
};

export const Relations = [{
  value: 'Father', label: 'Father'
}, {
  value: 'Mother', label: 'Mother'
}, {
  value: 'Guardian', label: 'Guardian'
}]

export const CollegeType = {
  1: 'Dream',
  2: 'Safe',
  3: 'Target'
}


export const CalendarEventType = {
  application: 'APPLICATION_DEADLINE',
  exam: 'EXAM',
  task: 'TASK_REMINDER',
  counselling: 'COUNSELING_SESSION',
  other: 'OTHER'
}

export const EventCateory = [{
  value: 'APPLICATION_DEADLINE', label: 'Application Deadlines'
}, {
  value: 'EXAM', label: 'Exams & Tests'
}, {
  value: 'TASK_REMINDER', label: 'Task Reminders'
}, {
  value: 'COUNSELING_SESSION', label: 'Counseling Sessions'
}, {
  value: 'OTHER', label: 'Other'
}];


export const TicketCategory = [{
  value: 'TECHNICAL', label: 'Technical'
}, {
  value: 'BILLING', label: 'Billing'
}, {
  value: 'ACCOUNT', label: 'Account'
}, {
  value: 'GENERAL', label: 'General'
}];

export const Reminders = [{
  value: 'FIFTEEN_MIN', label: '15 Min Before'
}, {
  value: 'THIRTY_MIN', label: '30 Min Before'
}, {
  value: 'ONE_HOUR', label: '1 Hour Before'
}, {
  value: 'ONE_DAY', label: '1 Day Before'
}, {
  value: 'ONE_WEEK', label: '1 Week Before'
}];

export const Repeats = [{
  value: 'NEVER', label: 'Does not Repeat'
}, {
  value: 'DAILY', label: 'Daily'
}, {
  value: 'WEEKLY', label: 'Weekly'
}, {
  value: 'MONTHLY', label: 'Monthly'
}, {
  value: 'YEARLY', label: 'Yearly'
}];

export const EventType = {
  1: 'ONE_ON_ONE',
  2: 'NEWSLETTER',
  3: 'COUNSELLING'
};

export const EventStatus = {
  1: 'SCHEDULED',
  2: 'CANCELLED',
  3: 'COMPLETED'
};

export const tabs = [
  {
    id: 0,
    activeIcon: "/Images/activepersonalprofile.png",
    label: "Personal Info"
  },
  {
    id: 1,
    activeIcon: "/Images/academic.png",
    label: "My Academic Information"
  },
  {
    id: 2,
    activeIcon: "/Images/activeextraactivity.png",
    label: "My Extra Curricular Activities"
  },
  {
    id: 3,
    activeIcon: "/Images/activecodingskills.png",
    label: "My Coding/Technology/Skills"
  },
  {
    id: 4,
    activeIcon: "/Images/activeresearchproject.png",
    label: "My STEM Research Projects"
  },
  {
    id: 5,
    activeIcon: "/Images/activestudentintake.png",
    label: "My Student Intake Form"
  },
  {
    id: 6,
    activeIcon: "/Images/transcript.png",
    label: "My Transcripts/Certificates"
  }
];

export const ProfileTabs = {
  personalInfo: 0,
  academic: 1,
  curricular: 2,
  coding: 3,
  research: 4,
  intakeform: 5,
  certificates: 6
}

export const validateEmail = (email) => {
  // Rejects .co but allows .com, .co.uk, .co.in, etc.
  const emailRegex = /^[^\s@]+@[^\s@]+\.[a-zA-Z]{2,}(?:\.[a-zA-Z]{2,})?$/;
  
  // Additional check to reject .co as final TLD
  if (emailRegex.test(email)) {
    const tld = email.split('.').pop();
    return tld !== 'co';
  }
  
  return false;
};


export const CarouselItems = [
  {
    id: 1,
    variant: 'default',
    background: '/Images/hero_background.png',
    indicatorColor: theme.palette.primary.main,
    textColor: theme.palette.primary.main,
    headingColor: theme.palette.common.white,
    title: "Your College Journey, Simplified",
    subtitle: "Dream College Planner guides you every step of the way to your Dream College",
    description: "Build a strong academic profile, discover your best-fit colleges, track important deadlines, and receive expert guidance — All in one AI integration planning platform",
    stats: [
      { value: "3,000+", label: "Colleges" },
      { value: "50,000+", label: "Students" },
      { value: "98%", label: "Success Rate" }
    ]
  },
  {
    id: 2,
    variant: 'variant2',
    background: '/Images/background2.png',
    indicatorColor: theme.palette.primary.main,
    textColor: theme.palette.primary.main,
    headingColor: theme.palette.common.white,
    title: "Your College Journey, Simplified",
    subtitle: "Dream College Planner guides you every step of the way to your Dream College",
    description: "Build a strong academic profile, discover your best-fit colleges, track important deadlines, and receive expert guidance — All in one AI integration planning platform",
    stats: [
      { value: "3,000+", label: "Colleges" },
      { value: "50,000+", label: "Students" },
      { value: "98%", label: "Success Rate" }
    ]
  },
  {
    id: 3,
    variant: 'variant3',
    background: '/Images/background3.png',
    indicatorColor: theme.palette.primary.main,
    textColor: theme.palette.primary.main,
    headingColor: theme.palette.common.white,
    title: "Your College Journey, Simplified",
    subtitle: "Dream College Planner guides you every step of the way to your Dream College",
    description: "Build a strong academic profile, discover your best-fit colleges, track important deadlines, and receive expert guidance — All in one AI integration planning platform",
    stats: [
      { value: "3,000+", label: "Colleges" },
      { value: "50,000+", label: "Students" },
      { value: "98%", label: "Success Rate" }
    ]
  }
];

export const Abouts = [{
  image: '/Images/AboutStudent.png',
  title: 'Students',
  subtitle: 'Navigate your college journey with confidence using personalized college recommendations, academic planning tools, and step-by-step guidance tailored to your goals.'
},
{
  image: '/Images/AboutParent.png',
  title: 'Parents',
  subtitle: 'Stay informed and involved with real-time progress tracking, important deadline alerts, and transparent communication — all in one place.'
},
{
  image: '/Images/AboutCounsellor.png',
  title: 'Counselors',
  subtitle: 'Empower students with data-driven insights, organized profiles, and streamlined workflows that make guidance more effective and impactful.'
},
{
  image: '/Images/tutors.png',
  title: 'Tutors & Mentors',
  subtitle: 'Support student growth beyond the classroom by tracking academic progress, aligning mentorship goals, and contributing insights that strengthen each student’s overall profile.'
}];

export const Features = [{
  images: <CommonFeatureIcon icon={<Person sx={{ fontSize: '40px' }} />} />,
  title: 'Secure Sign-Up & Account Verification',
  color: '#96CDF8',
  fontColor: theme.palette.secondary.main,
},
{
  images: <CommonFeatureIcon icon={<School sx={{ fontSize: '40px' }} />} />,
  title: 'Student Academic Profile Builder',
  color: theme.palette.secondary.main,
  fontColor: 'white',
},
{
  images: <img src="/Images/feature_3.png" alt="feature" />,
  title: 'AI Integrated College Planner Dashboard',
  color: theme.palette.secondary.main,
  fontColor: 'white',
},
{
  images: <img src="/Images/feature_4.png" alt="feature" />,
  title: 'Personalized College Wishlist',
  color: theme.palette.secondary.main,
  fontColor: 'white',
},
{
  images: <img src="/Images/feature_5.png" alt="feature" />,
  title: 'SAT/ACT Prep Support',
  color: 'white',
  fontColor: theme.palette.secondary.main,
},
{
  images: <img src="/Images/feature_6.png" alt="feature" />,
  title: 'Strategic Student Planning - Powered by Experts',
  color: '#96CDF8',
  fontColor: theme.palette.secondary.main,
},
{
  images: <CommonFeatureIcon icon={<CalendarMonth sx={{ fontSize: '40px' }} />} />,
  title: 'AI-Powered Smart Calendar & Alerts',
  color: 'white',
  fontColor: theme.palette.secondary.main,
},
{
  images: <CommonFeatureIcon icon={<Redeem sx={{ fontSize: '40px' }} />} />,
  title: 'AI-Enabled Progress Tracking & Achievement Rewards',
  color: '#96CDF8',
  fontColor: theme.palette.secondary.main,
},
{
  images: <img src="/Images/feature_9.png" alt="feature" />,
  title: 'Parent Access & Academic Partnership',
  color: '#96CDF8',
  fontColor: theme.palette.secondary.main,
}];

export const Stories = [{
  images: '/Images/storiesauthor.png',
  name: 'Rosa Santiago',
  position: 'Bachelor of Visual Communication Design',
  description: '“Dream college path is where I discovered my creative identity. The supportive environment pushed me to experiment, collaborate, and grow into a confident designer ready for the real world.”',
},
{
  images: '/Images/storiesauthor.png',
  name: 'Rosa Santiago',
  position: 'Bachelor of Visual Communication Design',
  description: '“Dream college path is where I discovered my creative identity. The supportive environment pushed me to experiment, collaborate, and grow into a confident designer ready for the real world.”',
},
{
  images: '/Images/storiesauthor.png',
  name: 'Rosa Santiago',
  position: 'Bachelor of Visual Communication Design',
  description: '“Dream college path is where I discovered my creative identity. The supportive environment pushed me to experiment, collaborate, and grow into a confident designer ready for the real world.”',
},
{
  images: '/Images/storiesauthor.png',
  name: 'Rosa Santiago',
  position: 'Bachelor of Visual Communication Design',
  description: '“Dream college path is where I discovered my creative identity. The supportive environment pushed me to experiment, collaborate, and grow into a confident designer ready for the real world.”',
},
{
  images: '/Images/storiesauthor.png',
  name: 'Rosa Santiago',
  position: 'Bachelor of Visual Communication Design',
  description: '“Dream college path is where I discovered my creative identity. The supportive environment pushed me to experiment, collaborate, and grow into a confident designer ready for the real world.”',
},
{
  images: '/Images/storiesauthor.png',
  name: 'Rosa Santiago',
  position: 'Bachelor of Visual Communication Design',
  description: '“Dream college path is where I discovered my creative identity. The supportive environment pushed me to experiment, collaborate, and grow into a confident designer ready for the real world.”',
}];

export const VerificationMethod = {
  mobile: 'MOBILE',
  email: 'EMAIL'
}

export const SideBarOptions = [{
  label: 'Manage Users', icon: <Person sx={{ color: 'white' }} />, link: '/manage-users'
}, {
  label: 'Manage Mentors', icon: <People sx={{ color: 'white' }} />, link: '/manage-mentors'
}, {
  label: 'Manage DCP Projects', icon: <AccountTree sx={{ color: 'white' }} />, link: '/manage-dcp-projects'
}, {
  label: 'Manage Static Pages', icon: <Pages sx={{ color: 'white' }} />, link: '/manage-static-page'
}, {
  label: 'Manage FAQ', icon: <LiveHelp sx={{ color: 'white' }} />, link: '/manage-faq'
}, {
  label: 'Manage Blogs', icon: <MessageRounded sx={{ color: 'white' }} />, link: '/manage-blogs'
}, {
  label: 'Manage Meetings', icon: <Groups sx={{ color: 'white' }} />, link: '/manage-meetings'
}, {
  label: 'Manage Send Alerts', icon: <AddAlert sx={{ color: 'white' }} />, link: '/manage-alert'
}, {
  label: 'Newsletter', icon: <svg width="24" height="24" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
    <path d="M3 8.5L12 15L21 8.5V18C21 18.8284 20.3284 19.5 19.5 19.5H4.5C3.67157 19.5 3 18.8284 3 18V8.5Z" stroke="white" stroke-width="2" stroke-linejoin="round" />
    <path d="M3 8.5L12 15L21 8.5" stroke="white" stroke-width="2" stroke-linejoin="round" />
    <rect x="7" y="4" width="10" height="8" rx="1" stroke="white" stroke-width="2" fill="none" />
    <line x1="9" y1="7" x2="15" y2="7" stroke="white" stroke-width="2" stroke-linecap="round" />
    <line x1="9" y1="10" x2="15" y2="10" stroke="white" stroke-width="2" stroke-linecap="round" />
  </svg>, link: '/news-letter'
}, {
  label: 'Help Desk', icon: <HelpOutline sx={{ color: 'white' }} />, link: '/support-help-desk'
}];

export const MentorSideBarOptions = [{
  label: 'Dashboard', icon: <Dashboard sx={{ color: 'white' }} />, link: '/mentor-dashboard'
}, {
  label: 'My Students', icon: <Person sx={{ color: 'white' }} />, link: '/my-students'
}, {
  label: 'Schedule & Calendar', icon: <CalendarMonth sx={{ color: 'white' }} />, link: '/schedule-calendar'
}, {
  label: 'Communication Hub', icon: <Chat sx={{ color: 'white' }} />, link: '/communication-hub'
}];

export const generateRandomString = () => {
  return Math.random().toString(36).substring(2, 15) +
    Math.random().toString(36).substring(2, 15);
};

export const LoginType = {
  EMAIL: 'EMAIL',
  GOOGLE: 'GOOGLE',
  APPLE: 'APPLE'
};

export const ServiceModule = [{
  images: '/Images/servicemodule1.png',
  title: 'DCP Calendar & Notifications',
  link: '/my-dcp-calendar'
}, {
  images: '/Images/servicemodule2.png',
  title: 'Student Academic Performance Tracker',
  link: '/student-performace-tracker'
}, {
  images: '/Images/servicemodule3.png',
  title: 'Counseling Services',
  link: '/my-dcp-counsellor'
}, {
  images: '/Images/servicemodule4.png',
  title: 'DCP SAT/ACT Expert',
  link: '/my-dcp-sat-act-coach'
}, {
  images: '/Images/servicemodule5.png',
  title: ' DCP Tutoring (AP/Academic)',
  link: '/dcp-tutoring'
}, {
  images: '/Images/servicemodule6.png',
  title: 'DCP Build a Project',
  link: '/build-project'
}, {
  images: '/Images/servicemodule5.png',
  title: 'DCP Coding & Technology Skills',
  link: '/dcp-skill-coaching'
}];

export const ResourceModule = [{
  images: '/Images/servicemodule3.png',
  title: 'My DCP Counselor',
  link: '/my-dcp-counsellor'
}, {
  images: '/Images/servicemodule4.png',
  title: 'My DCP SAT/ACT Coach',
  link: '/my-dcp-sat-act-coach'
}, {
  images: '/Images/servicemodule5.png',
  title: 'My DCP Tutor',
  link: '/dcp-tutoring'
}, {
  images: '/Images/servicemodule7.png',
  title: 'My DCP Project Mentor',
  link: '/build-project'
}];

export const ServiceAbouts = [{
  image: '/Images/AboutStudent.png',
  title: 'Personalized Planning',
  subtitle: 'Customized guidance based on each student’s academic profile, interests, and long-term goals.'
},
{
  image: '/Images/AboutParent.png',
  title: 'Expert Guidance',
  subtitle: 'Human expertise combined with smart insights to help students make confident, informed decisions.'
},
{
  image: '/Images/AboutCounsellor.png',
  title: 'Centralized Hub',
  subtitle: 'One platform to manage planning, progress, communication, and college readiness from start to finish'
}];

export const ResourceAbouts = [{
  image: '/Images/AboutStudent.png',
  title: 'Expert Support, On Demand',
  subtitle: 'Connect directly with experienced counselors, tutors, and mentors whenever guidance is needed.'
},
{
  image: '/Images/AboutParent.png',
  title: 'Personalized for Your Goals',
  subtitle: 'Receive tailored support aligned with your academic profile, interests, and college aspirations.'
},
{
  image: '/Images/AboutCounsellor.png',
  title: 'AI Powered Guidance with a DCP Expert Touch',
  subtitle: 'One platform to manage planning, progress, communication, and college readiness from start to finish'
}];

export const ServiceFeatures = [{
  images: <CommonFeatureIcon icon={'DCP'} background={theme.palette.secondary.main} color={theme.palette.primary.main} />,
  title: 'DCP Calendar & Notifications',
  subTitle: 'Stay organized with a centralized calendar that tracks college applications, exams, deadlines, tasks, and important milestones — all in one place',
  color: '#96CDF8'
},
{
  images: <CommonFeatureIcon icon={'DCP'} background={theme.palette.secondary.main} color={theme.palette.primary.main} />,
  title: 'Student Academic Performance Tracker',
  subTitle: 'Understand where you stand and what to improve with personalized academic and extracurricular analysis, college readiness insights, and actionable recommendations.',
  color: theme.palette.primary.main,
},
{
  images: <CommonFeatureIcon icon={'DCP'} background={theme.palette.secondary.main} color={theme.palette.primary.main} />,
  title: 'DCP SAT/ACT Expert',
  subTitle: 'Improve your test performance with customized SAT/ACT study plans, diagnostics, progress tracking, and expert-driven preparation strategies.',
  color: 'white'
},
{
  images: <CommonFeatureIcon icon={'DCP'} background={theme.palette.secondary.main} color={theme.palette.primary.main} />,
  title: ' DCP Tutoring (AP/Academic)',
  subTitle: 'Receive one-on-one academic support in AP subjects with experienced tutors who focus on concept mastery, exam strategies, and consistent improvement.',
  color: '#96CDF8',
},
{
  images: <CommonFeatureIcon icon={'DCP'} background={theme.palette.secondary.main} color={theme.palette.primary.main} />,
  title: 'Counseling Services',
  subTitle: 'Get expert guidance at every step with access to experienced college counselors for strategy, school selection, essays, and application planning.',
  color: theme.palette.primary.main
},
{
  images: <CommonFeatureIcon icon={'DCP'} background={theme.palette.secondary.main} color={theme.palette.primary.main} />,
  title: 'DCP Build a Project',
  subTitle: 'Create meaningful, standout projects with structured mentorship, milestone tracking, and real-world impact — designed to strengthen college applications',
  color: 'white',
}];

export const ResourceFeatures = [{
  images: <CommonFeatureIcon icon={'DCP'} background={theme.palette.secondary.main} color={theme.palette.primary.main} />,
  title: 'DCP Counselor',
  subTitle: 'Receive personalized college admissions guidance from experienced counselors at every key decision.',
  footerDescription: 'DCP Counselors help students navigate the admissions process with clarity and confidence, offering structured strategies and personalized support aligned with each student’s aspirations.',
  data: [{
    title: 'One-on-one sessions tailored to your academic profile and goals'
  },
  {
    title: 'Concept mastery and exam readiness'
  },
  {
    title: 'Strategic application planning'
  }],
  color: '#96CDF8'
},
{
  images: <CommonFeatureIcon icon={'DCP'} background={theme.palette.secondary.main} color={theme.palette.primary.main} />,
  title: 'DCP SAT/ACT Coach',
  subTitle: 'Work with test-prep experts focused on improving performance and maximizing results.',
  footerDescription: 'DCP SAT/ACT Coaches design customized prep plans that address weaknesses, strengthen test strategies, and help students reach their target scores efficiently.',
  data: [{
    title: 'Personalized coaching based on diagnostic assessments'
  },
  {
    title: 'Targeted strategies to improve SAT/ACT scores'
  },
  {
    title: 'Progress tracking and focused skill-building'
  }],
  color: 'white',
},
{
  images: <CommonFeatureIcon icon={'DCP'} background={theme.palette.secondary.main} color={theme.palette.primary.main} />,
  title: 'DCP Tutor',
  subTitle: 'Strengthen academic performance with subject-specific tutoring and focused support.',
  footerDescription: 'DCP Tutors provide personalized academic assistance to help students excel in challenging coursework, build strong foundations, and improve grades consistently.',
  data: [{
    title: 'One-on-one tutoring for AP and advanced courses'
  },
  {
    title: 'Concept clarity, exam preparation, and academic confidence'
  },
  {
    title: 'Support across key academic subjects'
  }],
  color: 'white'
},
{
  images: <CommonFeatureIcon icon={'DCP'} background={theme.palette.secondary.main} color={theme.palette.primary.main} />,
  title: ' My Dcp Project Mentor',
  subTitle: 'Turn ideas into impactful projects with expert mentorship.',
  footerDescription: 'DCP Project Mentors guide students in creating meaningful, real-world projects that highlight leadership, initiative, and problem-solving skills — strengthening college applications.',
  data: [{
    title: 'Guidance from ideation to execution'
  },
  {
    title: 'Feedback on project quality, impact, and presentation'
  },
  {
    title: 'Support for building application-ready projects'
  }],
  color: theme.palette.primary.main
}];

export const ExamType = {
  SAT: 'SAT',
  ACT: 'ACT'
};

export const Certificate = {
  Transcripts: 'Transcripts',
  Certificates: 'Certificates'
}

export const ExamTypeArr = [{
  label: 'Quiz', value: 'QUIZ'
},
{
  label: 'Mid Terms', value: 'MID_TERMS'
},
{
  label: 'Finals', value: 'FINALS'
}];

export const TutoringType = {
  AP: 'AP Exam',
  ACADEMIC: 'Academic Exam'
};

export const ServiceTypes = {
  'AP Exam': 'AP_TUTORING',
  'Academic Exam': 'ACADEMIC_TUTORING'
};

export const PerforamcenExamType = {
  AP: 'AP Exam',
  ACADEMIC: 'Academic Exam'
};

export const SkillType = {
  JAVA: 'Java',
  PYTHON: 'Python',
  JAVASCRIPT: 'Javascript',
  FLUTTER: 'Flutter'
};

export const ExamTypes = {
  ACT_SAT: 'ACT_SAT',
  ACADEMIC: 'ACADEMICS',
  APEXAM: 'AP_EXAMS',
  SKILLS: 'SKILL',
  PROJECTMENTORING: 'PROJECT_MENTORING',
  COUNSELLING: 'Counselling'
}

export const TaskPriority = {
  HIGH: 'High Priority',
  MEDIUM: 'Medium Priority',
  LOW: 'Low Priority'
}

export const TasksPriority = {
  HIGH: 'High',
  MEDIUM: 'Medium',
  LOW: 'Low'
};

export const TaskStatus = {
  PENDING: 'PENDING',
  IN_PROGRESS: 'IN_PROGRESS',
  COMPLETED: 'COMPLETED',
  SKIPPED: 'SKIPPED'
};

export const TaskStatusDispaly = {
  PENDING: 'Pending',
  IN_PROGRESS: 'In Progress',
  COMPLETED: 'Completed',
  SKIPPED: 'Skipped'
};

export const TasksPriorityArr = [{
  label: 'High', value: 'HIGH'
},
{
  label: 'Medium', value: 'MEDIUM'
},
{
  label: 'Low', value: 'LOW'
}];

export const ProjecType = {
  DCP: 'DCP Projects',
  EXTERNAL: 'External Projects',
  EXPLORE: 'Explore / Start New'
};

export const StaticPageType = {
  ABOUT: 'ABOUT_US',
  TERMS: 'TERMS_AND_CONDITIONS',
  PRIVACY: 'PRIVACY_POLICY'
}

export const BlogStatus = {
  Draft: 'DRAFT',
  Published: 'PUBLISHED'
};

export const formatMessageTime = (dateTime) => {
  const now = moment();
  const messageDate = moment(dateTime);
  const diffInDays = now.diff(messageDate, 'days');
  if (messageDate.isSame(now, 'day')) {
    return messageDate.format('HH:mm');
  }
  if (diffInDays === 1) {
    return 'Yesterday';
  }

  if (messageDate.isSame(now, 'week')) {
    return messageDate.format('ddd, HH:mm');
  }

  if (messageDate.isSame(now, 'year')) {
    return messageDate.format('MMM D, HH:mm');
  }

  return messageDate.format('DD/MM/YY, HH:mm');
};

export const MentorStatus = {
  ACTIVE: 'Active',
  INACTIVE: 'In Active',
  INVITESENT: 'Invitation Sent'
}

export const TopUpServices = [{
  label: 'SAT/ACT Coaching', image: '/Images/activesatact.svg', color: 'white', background: theme.palette.secondary.main, examType: ExamTypes.ACT_SAT
},
{
  label: 'AP & Academic Tutoring', image: '/Images/apacademic.svg', color: '#C53636', background: '#F3D0D0', examType: [ExamTypes.ACADEMIC, ExamTypes.APEXAM]
},
{
  label: 'Project Mentoring', image: '/Images/mentoring.svg', color: '#23A22A', background: '#D0FFD3', examType: ExamTypes.PROJECTMENTORING
},
{
  label: 'Counseling', image: '/Images/counselling.svg', color: '#126CAD', background: '#C3E5FD', examType: ExamTypes.COUNSELLING
},
{
  label: 'Skills', image: '/Images/skills.svg', color: '#A92271', background: '#F9CDE6', examType: ExamTypes.SKILLS
}];

export const ChatBotOption = [{
  label: 'SAT/ACT Coach', image: '/Images/satact.svg', color: theme.palette.primary.main, background: '#FFFCCF', examType: ExamTypes.ACT_SAT, value: 'SAT_ACT_COACH'
},
{
  label: 'AI Tutor', image: '/Images/apacademic.svg', color: '#C53636', background: '#F3D0D0', examType: [ExamTypes.ACADEMIC, ExamTypes.APEXAM], value: 'AI_TUTOR'
},
{
  label: 'AI Project Mentor', image: '/Images/mentoring.svg', color: '#23A22A', background: '#D0FFD3', examType: ExamTypes.PROJECTMENTORING, value: 'AI_PROJECT_MENTOR'
},
{
  label: 'AI Counselor', image: '/Images/counselling.svg', color: '#126CAD', background: '#C3E5FD', examType: ExamTypes.COUNSELLING, value: 'AI_COUNSELOR' 
},
{
  label: 'Skills / Technology', image: '/Images/coding.svg', color: '#A92271', background: '#F9CDE6', examType: ExamTypes.SKILLS, value: 'SKILLS_TECH'
}];

export const TimeBlocks = [{
  label: 'Quick Sync', value: '$95', time: '2 Hour', popular: false
}, {
  label: 'Standard Pack', value: '$870', time: '10 Hour', popular: true
}, {
  label: 'Intensive', value: '$370', time: '20 Hour', popular: false
}, {
  label: 'Mastery', value: '$470', time: '40 Hour', popular: false
}]

export const ExamPlans = [{
  id: 1,
  name: 'Gold',
  price: 19,
  isActive: true
},
{
  id: 2,
  name: 'Platinum',
  price: 39,
  isActive: false
},
{
  id: 3,
  name: 'Diamond',
  price: 79,
  isActive: false,
}];

export const ExamStatus = [{
  label: 'Enrolled', value: 'ENROLLED'
},
{
  label: 'Re-Enrolled', value: 'REENROLLED'
}, {
  label: 'In Progress', value: 'INPROGRESS'
}, {
  label: 'Completed', value: 'COMPLETED'
}];

export const UserTypeId = {
  Student: 3,
  Mentor: 5,
  Admin: 2,
  Parent: 4
}

export const TestSources = [{
  label: 'Official Practice Test 1', value: 'Official Practice Test 1'
}, {
  label: 'Official Practice Test 2', value: 'Official Practice Test 2'
}, {
  label: 'Official Practice Test 3', value: 'Official Practice Test 3'
}];

export const ServiceType = [{
  label: 'SAT/ACT Coach', value: 'SAT_ACT_COACHING'
},
{
  label: 'AP Tutoring', value: 'AP_TUTORING'
},
{
  label: 'Academic Tutoring', value: 'ACADEMIC_TUTORING'
},
{
  label: 'Counseling', value: 'COUNSELING'
},
{
  label: 'Project Mentoring', value: 'PROJECT_MENTORSHIP'
},
{
  label: 'Coding Skills & Technology', value: 'CODING_SKILLS_TECHNOLOGY'
}];

export const serviceOptions = [
  { value: 'SAT_ACT_COACHING', label: 'SAT/ACT Coaching' },
  { value: 'AP_TUTORING', label: 'AP Tutoring' },
  { value: 'ACADEMIC_TUTORING', label: 'Academic Tutoring' },
  { value: 'CODING_SKILLS_TECHNOLOGY', label: 'Coding Skills & Technology' },
  { value: 'PROJECT_MENTORSHIP', label: 'Project Mentorship' },
  { value: 'COUNSELING', label: 'Counselling' }
];

export const checkAllMentorFieldsPresent = (user) => {
  const mentorFields = [
    user?.mentor?.bio,
    user?.mentor?.calendly_meeting_link,
    user?.mentor?.degree,
    user?.mentor?.experience_years,
    user?.mentor?.expertise,
    user?.mentor?.service_offers,
    user?.mentor?.experiences
  ];

  // Check if all fields are present and arrays have length > 0
  const allFieldsPresent = mentorFields.every(field => {
    // Check if field is null or undefined
    if (field === null || field === undefined) {
      return false;
    }

    // For service_offers and experiences, check if they're arrays with length > 0
    if (field === user?.mentor?.service_offers || field === user?.mentor?.experiences) {
      return Array.isArray(field) && field.length > 0;
    }

    // For other fields, just check if they're not null/undefined
    return true;
  });

  return allFieldsPresent;
};

export const ExpierienceYears = [{
  label: '0-2 Years', value: 1
},
{
  label: '3-5 Years', value: 2
},
{
  label: '5+ Years', value: 3
}];

export const Expertise = [{
  label: 'Mathematics', value: 'Mathematics'
},
{
  label: 'Python', value: 'Python'
},
{
  label: 'Career Guidance', value: 'Career Guidance'
}];

export const ServiceTabs = {
  coach: 'SAT/ACT Coach',
  tutor: 'AP Tutoring',
  academic: 'Academic Tutoring',
  counsellor: 'Counselling',
  mentor: 'Project Mentoring',
  skillCoach: 'Skill/Technology Coach'
}

export const ServiceOffer = {
  coach: 'SAT_ACT_COACHING',
  tutor: 'AP_TUTORING',
  academic: 'ACADEMIC_TUTORING',
  counsellor: 'COUNSELING',
  mentor: 'PROJECT_MENTORSHIP',
  skillCoach: 'CODING_SKILLS_TECHNOLOGY'
}

export const ApplicationStatus = [{
  label: 'Early Action', value: 'Early Action'
},
{
  label: 'Regular Decision', value: 'Regular Decision'
}];

export const ProgressStatus = [{
  label: 'On Track', value: 'ON_TRACK'
},
{
  label: 'Needs Attention', value: 'NEEDS_ATTENTION'
},
{
  label: 'Critical/Behind', value: 'CRITICAL'
}];

export const ProgressStatusObj = {
  OnTrack: 'ON_TRACK',
  Needs: 'NEEDS_ATTENTION',
  Critical: 'CRITICAL'
}


export const TaskCategory = [{
  label: 'Essay', value: 'Essay'
}, {
  label: 'Application', value: 'Application'
}, {
  label: 'Financial Aid', value: 'Financial Aid'
}];

export const DocumentType = {
  Transcripts: 'TRANSCRIPT',
  Certificates: 'CERTIFICATE'
}

export const TicketStatus = {
  'All Tickets': 'ALL',
  Open: 'OPEN',
  Closed: 'CLOSED'
}

export const TicketDisplayStatus = {
  OPEN: 'Open',
  IN_PROGRESS: 'In Progress',
  CLOSED: 'Closed'
}

export const Semesters = {
  'Semester 1': 'SEMESTER_1',
  'Semester 2': 'SEMESTER_2',
}

export const TestType = {
  Assignments: 'ASSIGNMENT',
  Quizzes: 'QUIZ',
  Tests: 'TEST'
}

export const SkillPath = '/dcp-skill-coaching';

export const InvitationStatus = {
  Accept: 'ACCEPTED',
  Reject: 'DECLINED'
}

export const MentorMileStoneStatus = [{
  label: 'Approved', value: 'APPROVED'
}, {
  label: 'Request Changes', value: 'REQUEST_CHANGES'
}];

export const StudentMileStoneStatus = [{
  label: 'Current', value: 'CURRENT'
}, {
  label: 'Completed', value: 'COMPLETED'
}];

export const CHATBOX_STRINGS = {
    // Buttons
    NEW_CHAT_SESSION: 'New Chat Session',
    EXPORT: 'Export',
    SEND: 'Send',
    CLOSE: 'Close',

    // Sidebar - Search & Filter
    SEARCH_PLACEHOLDER: 'Search here',
    SELECT_AREAS: 'DCP AI Services',
    RECENT_HISTORY: 'Recent History',
    CHAT_NOT_FOUND: 'Chat Not Found',

    // Area Filter Buttons
    AREA_ALL: 'All',
    AREA_SAT_ACT: 'SAT/ACT Coach',
    AREA_AI_TUTOR: 'AI Tutor',
    AREA_AI_PROJECT_MENTOR: 'AI Project Mentor',
    AREA_AI_COUNSELLOR: 'AI Counselor',
    AREA_AI_SKILL_COACH: 'AI Skill Coach',

    // Initial Screen
    WELCOME_MESSAGE: 'How can I help you today?',

    // Chat Input Placeholders (by service type)
    PLACEHOLDER_DEFAULT: 'Ask me anything',
    PLACEHOLDER_SAT_ACT: 'Ask me anything about your SAT/ACT',
    PLACEHOLDER_AI_TUTOR: 'Ask me anything about your Ap/Academic',
    PLACEHOLDER_AI_PROJECT_MENTOR: 'Ask me anything about your project',
    PLACEHOLDER_AI_COUNSELOR: 'Ask me anything about your Counseling',
    PLACEHOLDER_SKILLS_TECH: 'Ask me anything about your Skill/Coding/Technology',

    // Chat Messages
    START_CONVERSATION: 'Start your conversation...',
    SELECT_OPTION_ERROR: 'Please select a chat option first',

    // Chat Details Dialog
    DIALOG_CHAT_DETAILS: 'Chat Details',
    DIALOG_CHAT_TITLE: 'Chat Title',
    DIALOG_CHAT_TOPIC: 'Chat Topic',
    DIALOG_CHAT_TYPE: 'Chat Type',
    DIALOG_TOTAL_MESSAGES: 'Total Messages',
    DIALOG_LAST_UPDATED: 'Last Updated',
    DIALOG_GENERAL_DISCUSSION: 'General Discussion',
    DIALOG_AI_ASSISTANT: 'AI Assistant',
    DIALOG_MESSAGES_SUFFIX: 'messages',
    DIALOG_DATE_FORMAT: 'MMMM DD, YYYY hh:mm A',

    // Notifications
    TITLE_UPDATED_SUCCESS: 'Title updated successfully',

    // Select Dropdown
    SELECT_AN_OPTION: 'Select an option',

    // Session defaults
    SESSION_DEFAULT_TITLE: 'DCP AI Assistant',

    // Image alts
    ALT_ATTACHMENT: 'attachment',
    ALT_SEND: 'send',
    ALT_ICON: 'icon',

    // Socket event
    SOCKET_EVENT_AI_RESPONSE: 'responseAIMessage',

    // File download
    FILE_DOWNLOAD_QUERY: '/file?bname=',
    FILE_DOWNLOAD_PARAM: '&download=true',

    // Time format
    TIME_FORMAT: 'hh:mm A',

    AI_TUTOR: 'AI_TUTOR',
    SAT_ACT_COACH: 'SAT_ACT_COACH',
    AI_PROJECT_MENTOR: 'AI_PROJECT_MENTOR',
    AI_COUNSELOR: 'AI_COUNSELOR',
    SKILLS_TECH: 'SKILLS_TECH',

    TYPING: 'Typing...',
};

export const ReceipientTypes = [
  {
    label: 'All', value: 'ALL'
  },
  {
    label: 'Individual', value: 'INDIVIDUAL'
  }
];